import { showMessageDetalhar } from "../detalhar/actions";

const INITIAL_STATE = {
  alerta: {},
  esperandoSolicitacao: false,
  erro: null,
  justificativa: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'REQUERIMENTO_CANCELAR_TAREFA_INICIAR':
      return { ...state, esperandoSolicitacao: true };
    case 'REQUERIMENTO_CANCELAR_REMOVE_LOADING':
      return { ...state, esperandoSolicitacao: false };
    case 'REQUERIMENTO_CANCELAR_LIMPAR_JUSTIFICATIVA':
      return { ...state, esperandoSolicitacao: false, justificativa: null };
    case 'REQUERIMENTO_CANCELAR_ALTERAR_JUSTIFICATIVA':
      return { ...state, esperandoSolicitacao: false, justificativa: action.payload };
    case 'REQUERIMENTO_CANCELAR_TAREFA_SUCESSO':
      return { ...state, esperandoSolicitacao: false }
    case 'REQUERIMENTO_CANCELAR_TAREFA_ERRO':
      return { ...state, esperandoSolicitacao: false, alerta: { message: action.payload, severity: 'error' } };
    case 'REQUERIMENTO_CANCELAR_CLOSE_MESSAGE':
      return { ...state, alerta: {} }
      case "PREENCHIMENTO_JUSTIFICATIVA_ERRO":
      return {
        ...state,
        esperandoSolicitacao: false,
        alerta: { message: action.payload, severity: "error" },
      };
    default:
      return state;
  }
}
